<template>
  <v-app>
    <tradana-navbar></tradana-navbar>
    <v-main>
      <router-view/>
    </v-main>
    <tradana-footer></tradana-footer>
  </v-app>
</template>

<script>
import Navbar from '@/components/global/Navbar.vue'
import Footer from '@/components/global/Footer.vue'

require('@/css/globalStyles.css')

export default {
  name: 'App',
  data: () => ({
    //
  }),
  components: {
    TradanaNavbar: Navbar,
    TradanaFooter: Footer
  }
}
</script>

<style>
div {
  color: var(--v-text-base)
}
</style>
